import React, { useState } from 'react';
import { ArrowLeftIcon, MapPinIcon, FlameIcon } from 'lucide-react';
import { cantones, categories, restaurants } from '../data/mockData';
import { RestaurantCard } from './RestaurantCard';
interface CantonViewProps {
  cantonId: string;
  onSelectRestaurant: (id: string) => void;
  onBack: () => void;
}
export function CantonView({
  cantonId,
  onSelectRestaurant,
  onBack
}: CantonViewProps) {
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const canton = cantones.find(c => c.id === cantonId);
  if (!canton) return null;
  const cantonRestaurants = restaurants.filter(r => r.cantonId === cantonId);
  const filteredRestaurants = activeCategory === 'all' ? cantonRestaurants : cantonRestaurants.filter(r => r.categoryId === activeCategory);
  return <div className="min-h-screen bg-bg-primary pb-24" data-id="element-12">
      {/* Header */}
      <div className="bg-bg-secondary border-b border-border pt-10 pb-8 px-4" data-id="element-13">
        <div className="max-w-7xl mx-auto" data-id="element-14">
          <button onClick={onBack} className="flex items-center gap-2 text-text-secondary hover:text-brand-gold font-body text-sm font-medium mb-6 transition-colors" data-id="element-15">
            <ArrowLeftIcon className="w-4 h-4" data-id="element-16" /> Volver al inicio
          </button>

          <div className="flex flex-col md:flex-row md:items-end justify-between gap-4" data-id="element-17">
            <div data-id="element-18">
              <div className="flex items-center gap-2 text-brand-orange mb-2" data-id="element-19">
                <MapPinIcon className="w-5 h-5" data-id="element-20" />
                <span className="font-body font-semibold uppercase tracking-wider text-sm" data-id="element-21">
                  Zona de Los Santos
                </span>
              </div>
              <h1 className="text-6xl md:text-7xl font-heading uppercase tracking-wide text-white" data-id="element-22">
                {canton.fullName}
              </h1>
              <p className="font-body text-text-secondary mt-2 text-lg max-w-2xl" data-id="element-23">
                {canton.description}
              </p>
            </div>
            <div className="bg-bg-card border border-border px-4 py-2 rounded-lg inline-flex items-center gap-2" data-id="element-24">
              <FlameIcon className="w-4 h-4 text-brand-orange" data-id="element-25" />
              <span className="font-heading text-2xl text-white" data-id="element-26">
                {cantonRestaurants.length}
              </span>
              <span className="font-body text-text-secondary" data-id="element-27">lugares</span>
            </div>
          </div>
        </div>
      </div>

      {/* Category Filter */}
      <div className="max-w-7xl mx-auto px-4 pt-8 pb-8" data-id="element-28">
        <p className="font-body text-xs text-text-muted uppercase tracking-wider font-semibold mb-3" data-id="element-29">
          Categoría
        </p>
        <div className="flex overflow-x-auto pb-4 gap-2" data-id="element-30">
          <button onClick={() => setActiveCategory('all')} className={`whitespace-nowrap px-4 py-2 rounded-lg font-body text-sm font-semibold transition-all ${activeCategory === 'all' ? 'bg-gradient-fire text-white' : 'bg-bg-card border border-border text-text-secondary hover:border-brand-orange/40'}`} data-id="element-31">
            Todos
          </button>
          {categories.map(cat => <button key={cat.id} onClick={() => setActiveCategory(cat.id)} className={`whitespace-nowrap px-4 py-2 rounded-lg font-body text-sm font-semibold transition-all ${activeCategory === cat.id ? 'bg-gradient-fire text-white' : 'bg-bg-card border border-border text-text-secondary hover:border-brand-orange/40'}`} data-id="element-32">
              {cat.name}
            </button>)}
        </div>

        {/* Grid */}
        {filteredRestaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6 mt-4" data-id="element-33">
            {filteredRestaurants.map((restaurant, index) => <RestaurantCard key={restaurant.id} restaurant={restaurant} onSelect={onSelectRestaurant} delay={index * 0.05} data-id="element-34" />)}
          </div> : <div className="text-center py-20" data-id="element-35">
            <div className="w-20 h-20 bg-bg-card rounded-full flex items-center justify-center mx-auto mb-4 border border-border" data-id="element-36">
              <MapPinIcon className="w-8 h-8 text-text-muted" data-id="element-37" />
            </div>
            <h3 className="font-heading text-2xl text-white mb-2" data-id="element-38">
              No hay resultados
            </h3>
            <p className="font-body text-text-secondary" data-id="element-39">
              Aún no tenemos lugares en esta categoría para {canton.name}.
            </p>
            <button onClick={() => setActiveCategory('all')} className="mt-6 text-brand-gold font-body font-semibold hover:underline" data-id="element-40">
              Ver todos los lugares
            </button>
          </div>}
      </div>
    </div>;
}